import styled from "styled-components";

export const ParcItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .pay-history {
    font-size: 0.8em;
  }
  .icon-pay-type {
    margin-right: 10px;
    color: #666;
  }
  .icon-partial {
    margin-right: 10px;
    color: #bbb;
    padding: 3px;
    :hover {
      background-color: #ddd;
    }
  }
  .ok {
    color: #00bf00;
  }

  .danger {
    color: #bf0000;
  }

  .pending {
    color: #666;
  }

  .icon-partial-separator {
    margin: 0 20px;
  }

  :not(:last-child) {
    border-bottom: 1px solid #ccc;
  }
  padding: 5px;

  :hover {
    background-color: #eee;
    cursor: pointer;
  }

  .partial-state {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
  /* boleto expandido (via=2): ocupa a linha inteira em vez dos ~10% da coluna de icones */
  .partial-state .boleto-api {
    flex: 1 1 100%;
    align-items: flex-start;
    text-align: left;
    margin-top: 6px;
  }
`;
